<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput :option="{placeholder:'账号名称 / 账号注册手机 / 续费菜单',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;}
                        if(val.type=='keydown') GetPlatForm();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetPlatForm()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'新增续费记录'}" @finish="AddRenew()" />
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" id="table-renew-obj">
        <el-table :data="renewlist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="expand" >
                <template #default="scope">
                    <el-table :data="scope.row.detail" stripe="true" empty-text="" class="TTL-table-child">
                        <template v-slot:empty><el-empty description="暂无数据" /></template>
                        <el-table-column prop="menu_name" label="续费功能" align="center"/>
                        <el-table-column prop="cost" label="续费金额" align="center">
                            <template #default="tscope">
                                <div class="money-style">{{tscope.row.cost}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="renewtime" label="续费时间 / 扩充容量" align="center">
                            <template #default="tscope">
                                <div>{{tscope.row.spacenum ? tscope.row.spacenum : tscope.row.renewtime}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="usetime" label="功能使用时间" align="center" />
                        <el-table-column prop="note" label="备注" align="center" />
                    </el-table>
                </template>
            </el-table-column>
            <el-table-column prop="shopname" label="商户名称"  align="center" />
            <el-table-column prop="phone" label="商户手机"  align="center" />
            <el-table-column prop="cost" label="续费信息" align="center">
                <template #default="tscope">
                    <div class="maangers">
                        {{tscope.row.pay_status==0 ? '平台续费' : '商家自行续费'}}-
                        <i>{{tscope.row.cost}}</i>
                    </div>
                    <div class="TTL-note-info" v-if="tscope.row.note!=''">{{'（'+tscope.row.note+'）'}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="managername" label="操作人"  align="center" />
            <el-table-column prop="inputtime" label="操作时间"  align="center" />
            <el-table-column prop="cost" label="相关支付单号" align="center">
                <template #default="tscope">
                    <div class="maangers-sub">{{tscope.row.transaction_id ? tscope.row.transaction_id : '/'}}</div>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-page TTL-page-right">
                <wcpage 
                    :row="param.rows" 
                    :p="param.p" 
                    :rollpage="param.rollpage" 
                    @finish="(val)=> {
                        param.p=val.p;
                        param.rollpage=val.rollpage;
                        GetPlatForm();
                    }"
                />
            </div>
        </div>
    </div>


</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
import INTERFACE_MODEL_RENEW from '@/Interface/Renew/renew';
export default {
    components:{},
    data() {
        return {
            param: {
                key:'',
                ischange:false,
                p:1,
                rollpage:10,
                rows:0,
            },
            renewlist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除账号'},
                {id:2,name:'批量编辑账号'},
            ],

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetPlatForm();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetPlatForm();
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetPlatForm();
            }else {
                this.GetPlatForm();
            }
        },


        /** 数据批操作处理 **/
        changehandle(index) {
            this.handlevalue='';
            var ids=this.GetSelectDataIds();
            if(ids.length == 0) {this.$notice({title:'消息提示',message:'请选择要批量执行的账号',type:'warning'});return false;}
            ids=ids.join(',');

            this.$confirm.confirm(
                '该操作将会批量修改数据，且不可恢复，是否执行 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                if(index==1) {
                    this.DelShopsMore(ids);
                }else if(index==2) {
                    this.EditShopMore(ids);
                }
               
            }).catch(()=> {
                
            });
        },


        /** 删除账号信息 **/
        DelShop(id) {
            this.$confirm.confirm(
                '您是否确定要删除当前账号 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.DelShopsMore(id);
            }).catch(()=> {
                
            });
        },


        /** 删除账号信息操作 **/
        DelShopsMore(ids) {
            INTERFACE_MODEL_SHOP.DEL_SHOPS({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.GetPlatForm();
            });
        },


        /** 编辑账号信息 **/
        EditShop(id) {
            this.EditShopMore(id);
        },

        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        //基础数据操作

        /** 获取平台账号inxi **/
        GetPlatForm() {
            if(this.param.ischange) {
                this.param.ischange=false;
                this.param.p=1;
                this.param.rollpage=10;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-renew-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_RENEW.GET_RENEW_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.renewlist=res.data.list;
            });
        },


        /** 新增续费信息 **/
        AddRenew() {
            var navinfo={name:'新增续费记录',labelentry:'AddPlatFormReNew',components:'AddPlatFormReNew',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 编辑管理员信息 **/
        EditShopMore(ids) {
            var navinfo={name:'编辑账号',labelentry:'EditPlatFormShop',components:'EditPlatFormShop',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.renewlist.length;i++) this.renewlist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.renewlist);
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.renewlist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },

        //基础数据操作
        ///////////////////////////////////////////////////////
        //////////////////////////////////////////////////////


    },
}
</script>
<style scoped>
.TTL-select-infos {display:inline-flex;align-items: center;}
.TTL-select-infos span {margin-left:10px;}
.TTL-pet-image {position: relative;display: inline-block;}
.TTL-image-box-sex {width:20px;height: 20px;position:absolute;right:0;top:0;margin-right:-5px;margin-top:-5px;border-radius: 50%;background:#ffffff;}
.TTL-image-box-small {border-radius: 50%;}
.TTL-isadmin {
    position:absolute;
    bottom:0;
    right:0;
    margin-right:-5px;
    width:25px;
    height:25px;
    border-radius: 50%;
    background-color: #ffffff;
    background-image:url(@/assets/icon/isplatform.png);
    background-repeat: no-repeat;
    background-size: 14px;
    background-position: center;
}
.money-style {color:red;font-weight: 550;}
.maangers i {color:red;font-weight: 550;font-style: normal;}
.maangerinfo {display: inline-block;width:100%;text-align: center;font-size: 12px;}
.maangers {display:inline-block;width:100%;}
.maangers-sub {display:inline-block;width:100%;font-size:12px;color:#666666;}
.TTL-names {font-weight: 550;display:inline-block;width:100%;letter-spacing: 1px;}
.TTL-names i {font-style: normal;font-weight: 500;color:#999999;font-size:12px;zoom:.9;}
.TTL-note {display:inline-block;width:100%;font-size:12px;color:#999999;}
.TTL-note-info {font-size:12px;color:#999999;zoom:.9}
.TTL-table-child {display:inline-block;width:calc(100% - 50px);padding:0 0 0 50px;}
</style>